<template>
    <Index v-if="pageType === 'index'" />
    <PortfolioWrapper v-if="pageType === 'ownDomain'" :ownDomainError="error" :ownDomainPassword="password" :ownDomainLoaded="loaded" :ownDomainComingSoon="comingSoon"/>
</template>

<script>
import PortfolioWrapper from "./PortfolioWrapper.vue";
import Index from "../Index.vue";
import {checkFonts} from "../../settingsEditor/_helpers/fontLoaders.js";
import GoogleFontsHelper from "../../common/GoogleFontsHelper.js";
import ApiHelper from "../../api/ApiHelper.js";
import {resolveColor} from "@/scripts/common/helpers.js";
import {mapGetters} from "vuex";
import {store} from "@/scripts/store/FolioStore.js";
import {isPrerenderedDocument} from "@/scripts/common/prerenderedDocument.js";

export default {
    name: "LandingWrapper",
    components: {PortfolioWrapper, Index},
    data() {
        return {
            pageType: null,
            error:null,
            password:null,
            loaded:false,
            comingSoon: false,
        }
    },
    async beforeRouteEnter(to, from, next) {
        // Prerendered pages are only served on the UXfolio host, never on own domains.
        if (typeof window !== "undefined" && (window.__UXFOLIO_PRERENDER__ || isPrerenderedDocument)) {
            next(vm => {
                vm.decideView(false);
            });
            return;
        }

        let req = new XMLHttpRequest();
        req.open('GET', document.location.origin, false);
        req.send(null);
        let header = req.getResponseHeader('x-folio-forwarded-host');

        //Owndomain
        if(!!header) {
            next(vm => {
                vm.loadPortfolioIfNeeded();
            });
        }
        //index
        else {
            next(vm => {
                vm.decideView(false)
            });
        }
    },
    methods: {
        async decideView(isOwnDomain) {
            if(isOwnDomain) {
                this.setData('', 'ownDomain')
            }
            else {
                this.setData('', 'index')
            }
        },
        setData(data, pageType) {
            this.pageType = pageType;
        },
        async loadPortfolioIfNeeded() {
            if(this.ownDomainPortfolioIsLoaded) {
                const storePages = this.viewData.portfolioPages;
                this.$store.commit('view/updateViewProject', storePages.find(p => p.shortId === "home"));
                this.$store.commit('view/updateActivePage', "home");
                this.$store.state.project = storePages.find(p => p.shortId === "home");
                this.error = false;
                this.password = false;
                this.comingSoon = false;
                this.loaded = true;
                store.commit("view/updateViewModeReadiness", true)
                await this.decideView(true)
            }
            else {
                try {
                    let res = await ApiHelper.get('/data/ownDomain');
                    this.loadPortfolioData(res.status, res.data);
                    await this.decideView(true)
                } catch(err) {
                    this.loadPortfolioData(err, null)
                    this.decideView(true)
                }

            }
        },
        loadPortfolioData(err, data) {
            if(err && !data) {
                if(err.response.status === 404) {
                    this.error = true;
                    this.loaded = true;
                    return;
                } else if (err.response.status === 401) {
                    this.comingSoon = true;
                    this.loaded = true;
                    return;
                }
                if (err.response?.data) {
                    this.applyViewData(this.buildViewDataFromResponse(err.response?.data));
                }
                this.password = true;
                this.loaded = true;
                return;
            }
            else {
                this.error = false;
                this.password = false;
            }

            this.applyViewData(this.buildViewDataFromResponse(data));
            this.loaded = true;
        },
        buildViewDataFromResponse(data) {
            //Load fonts
            if(!this.viewData.fontsLoaded) {
                checkFonts(data.fonts)
                //load legacy fonts
                let legacyFonts = data.fontNames.filter((fontName) => !data.fonts.map(x => x.name).includes(fontName))
                legacyFonts.forEach((name) =>{
                    GoogleFontsHelper.getFontURL(name);
                })
                this.$store.commit("view/setFontsLoaded", true);
            }

            return {
                portfolio:data.portfolio,
                project:data.project,
                user:data.user,
                portfolioPages:data.portfolioPages,
                activePage:data.project.shortId,
                caseStudies:data.caseStudies,
                hasDraftCasestudies:data.hasDraftCasestudies,
                loggedInUserId:data.loggedInUserId
            };
        },
        applyViewData(viewData) {
            this.password = false;
            this.$store.commit('view/updateView', viewData);

            if(!viewData.portfolio.templateSettings.theme.includes('profile_')) {
                try {
                    import(`../../../styles/_${viewData.portfolio.templateSettings.theme.replaceAll('_', '-').replace('profile_', '')}-base.scss`);
                }
                catch (e) {
                    console.log('failed to import scss')
                }
            }

            store.commit("view/updateViewModeReadiness", true)
            //TODO: figure this ourt
            this.$store.state.portfolio = viewData.portfolio
            this.$store.state.project = viewData.project
        },
    },
    computed: {
        ...mapGetters("view", ["viewData"]),
        ownDomainPortfolioIsLoaded() {
            return this.viewData.portfolio && this.viewData.portfolio.ownDomainAddress && location.origin.includes(this.viewData.portfolio.ownDomainAddress);
        },
    }
}
</script>